import { Component, OnInit } from '@angular/core';
import { SmsService } from 'src/app/services/sms.service';
import { Router } from '@angular/router';
import { User } from 'firebase';
import { ToastrService } from 'ngx-toastr';
import { Admin } from 'src/app/models/admin';
import { Quiniela } from 'src/app/models/quiniela';
import { Visita } from 'src/app/models/visita';
import { Partido } from 'src/app/models/partido';
import { Plantilla } from "src/app/models/plantilla";
import { AuthService } from 'src/app/services/auth.service';
import { QuinielasService } from 'src/app/services/quinielas.service';
import { AdminService } from 'src/app/services/admin.service';
import { JugadorService } from 'src/app/services/jugadores.service';
import { PartidosService } from 'src/app/services/partidos.service';
import { PlantillasService } from "src/app/services/plantillas.service";
import { QuinielaJugadaService } from 'src/app/services/quiniela-jugada.service';
import { TablaService } from 'src/app/services/tabla.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-admin-page',
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.css']
})
export class AdminPageComponent implements OnInit {
  isLoading = false;
  user: User = null;
  isAuthenticated = false;
  admins: Array<Admin> = [];
  isVerified = false;
  quinielas: Array<Quiniela> = [];
  visitas: Array<Visita> = [];
  partidos = [];


  constructor(
    private authService: AuthService,
    private QuinielasService: QuinielasService,
    private AdminService: AdminService,
    private JugadoresService: JugadorService,
    private PlantillasService: PlantillasService,
    private PartidosService: PartidosService,
    private QuinielaJugadaService: QuinielaJugadaService,
    private TablaService: TablaService,
    private router: Router,
    private toastr: ToastrService,
    private SmsService: SmsService,
  ) { }

  ngOnInit(): void {
    this.getCurrentUser();
    this.getPlatilla();
  }

  getCurrentUser(): void {
    this.isLoading = true;
    this.authService.getCurrentUser().subscribe((response) => {
      if (response) {
        this.user = response;
        this.isAuthenticated = true;
        this.isLoading = false;
        this.getAllQuinielas();
        return;
      }
      this.isLoading = false;
      this.isAuthenticated = false;
    });
  }

  // Obtener las Quinielas
  getAllQuinielas(): void {
    this.isLoading = true;
    this.QuinielasService.getAllQuinielas().subscribe((items) => {
      // Setting up quinielas
      this.quinielas = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Quiniela)
      );
      // Ordenar por fecha de creacion
      this.quinielas.sort(function (a, b) {
        var c = new Date(a.fecha) as any;
        var d = new Date(b.fecha) as any;
        console.log("c:" + c);
        console.log("d:" + d);
        return c - d;
      });
      this.quinielas.reverse();
      // Terminar cargando
      this.isLoading = false;
    });
  }


  comprobar() {
    this.isLoading = true;
    // Datos a enviar a DB para Comprobar
    var email = this.user.email;
    var pin = parseInt((<HTMLInputElement>document.getElementById("PIN")).value);
    // Consultando con DB
    this.AdminService.getAdmin(email).subscribe((items) => {
      // Setting up admins
      this.admins = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Admin)
      );
      console.log(this.admins);
      if (this.admins.length != 0) {
        this.isLoading = false;
        this.isVerified = true;
      }
    });
  }

  buscar() {
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("buscarInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("tableQuinielas");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

  editar(quiniela: Quiniela) {
    // Control para evitar submit de editar en caso que falte algo
    let error = false;

    // ID de la Quiniela
    var id = quiniela.$key;

    // Validando los inputs que no esten vacios
    const inputs = ["Telefono-" + id, "Email-" + id, "Titulo-" + id, "URL-" + id, "Precio-" + id, "Moneda-" + id, "Porcentaje-" + id, "DatosPago-" + id];
    inputs.map(function (id) {
      document.getElementById(id).classList.remove('is-invalid')
      if ((<HTMLInputElement>document.getElementById(id)).value == '') {
        document.getElementById(id).classList.add('is-invalid')
        error = true
      } else {
        document.getElementById(id).classList.add('is-valid')
      }
    });

    // Si error es Falso entonces se procede a crear el Objeto y enviar por medio del Servicio
    if (!error) {
      // Limpiar las alertas del Formulario
      inputs.map(function (id) {
        document.getElementById(id).classList.remove('is-valid')
      });

      // Cerrando Modal
      (<HTMLInputElement>document.getElementById("CloseEditarButton-" + id)).click();

      // Enviar el Alerta
      this.toastr.success('Se ha editado con éxito su Quiniela!');

      // Obteniendo todos las Formas de Pago selecionadas 
      const checkboxes = document.querySelectorAll('input[name="' + id + '"]:checked');

      // Introduciendolas en un Vector
      let FormasPago = [];
      checkboxes.forEach((checkbox) => {
        FormasPago.push((checkbox as HTMLInputElement).value);
      });
      // Imprimiendo las Formas de Pago
      console.log(FormasPago)

      // Creando el Objeto con el Modelo
      const dataQuiniela: Quiniela = {
        email: (<HTMLInputElement>document.getElementById("Email-" + id)).value,
        titulo: (<HTMLInputElement>document.getElementById("Titulo-" + id)).value,
        descripcion: (<HTMLInputElement>document.getElementById("Descripcion-" + id)).value,
        url: quiniela.url,
        datos_de_pago: (<HTMLInputElement>document.getElementById("DatosPago-" + id)).value,
        precio: parseInt((<HTMLInputElement>document.getElementById("Precio-" + id)).value),
        moneda: (<HTMLInputElement>document.getElementById("Moneda-" + id)).value,
        porcentaje: parseInt((<HTMLInputElement>document.getElementById("Porcentaje-" + id)).value),
        activa: quiniela.activa,
        telefono: (<HTMLInputElement>document.getElementById("Telefono-" + id)).value,
        user: quiniela.user,
        numero: quiniela.numero,
        pote: quiniela.pote,
        empezada: quiniela.empezada,
        fecha: quiniela.fecha,
      };

      // Enviar a Firebase mediante el Servicio
      this.QuinielasService.updateQuiniela(dataQuiniela, id).then((res) => {
        console.log("Se ha editado con exito la Quiniela", dataQuiniela);
      });
    }
  }

  eliminar(quiniela: Quiniela): void {

    Swal.fire({
      title: 'Atención',
      text: "¿Estas seguro que deseas eliminar esta quiniela?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        let timerInterval
        Swal.fire({
          title: 'Eliminando',
          html: 'Se esta eliminando la quiniela.Por favor espere <b></b> millisegundos.',
          timer: 10000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading()
            const b = Swal.getHtmlContainer().querySelector('b')
            timerInterval = setInterval(() => {
              b.textContent = `${Swal.getTimerLeft()}`
            }, 100)
          },
          willClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            console.log('I was closed by the timer');
            this.toastr.success('La quiniela fue eliminada con éxito!');
          }
        })

        // Enviar a Firebase mediante el Servicio
        this.QuinielasService.deleteQuiniela(quiniela.$key).then((res) => {
          console.log("Se ha borrado logicamente con exito la Quiniela");
        });

        this.JugadoresService.deleteAllJugadoresByIdQuiniela(quiniela.$key);

        this.PartidosService.deleteAllPartidosByIdQuiniela(quiniela.$key);

        this.QuinielaJugadaService.deleteAllQuinielasJugadasByIdQuiniela(quiniela.$key);

        this.TablaService.deleteTablaByIdQuiniela(quiniela.$key);

        // Enviar SMS avisando que se registro con exito
        var numero = "+584122924248";
        var texto = "*TuQuinielaYa:* La quiniela " + quiniela.titulo + " ha sido eliminada.";
        this.SmsService.enviar(numero, texto);

      }
    });

  }

  getPlatilla(): void {
    this.PlantillasService.getAllPlantillas().subscribe((items) => {
      var plantillas = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Plantilla)
      );

      if (plantillas.length != 0) {
        const partidos = JSON.parse(plantillas[0].data);
        console.log(partidos.data);
        this.partidos = partidos;
      }
    });
  }

  eliminarPartidioPlantilla(partido): void {
    this.partidos.forEach((item, index) => {
      if (item === partido) this.partidos.splice(index, 1);
    });
    console.log(partido);
  }

  cargarPartidoPlantilla(): void {
    var partidoPlantilla = {
      fecha: (<HTMLInputElement>document.getElementById("Fecha")).value,
      contrincante1: (<HTMLInputElement>document.getElementById("Equipo1")).value,
      contrincante2: (<HTMLInputElement>document.getElementById("Equipo2")).value,
    };

    // Velidar campos con datos
    var error = false;
    const inputs = ["Fecha", "Equipo1", "Equipo2"];
    inputs.map(function (id) {
      document.getElementById(id).classList.remove("is-invalid");
      if ((<HTMLInputElement>document.getElementById(id)).value == "") {
        document.getElementById(id).classList.add("is-invalid");
        error = true;
      } else {
        document.getElementById(id).classList.add("is-valid");
      }
    });

    if (!error) {
      this.partidos.push(partidoPlantilla);

      // Limpiar las alertas del Formulario
      inputs.map(function (id) {
        document.getElementById(id).classList.remove("is-valid");
      });
      // Limpiar el Formulario
      (<HTMLInputElement>document.getElementById("Fecha")).value = "";
      (<HTMLInputElement>document.getElementById("Equipo1")).value = "";
      (<HTMLInputElement>document.getElementById("Equipo2")).value = "";
    }
  }

  guardarPlantilla(): void {
    const PS = this.PlantillasService.getAllPlantillas().subscribe((items) => {
      var plantillas = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Plantilla)
      );
      PS.unsubscribe();

      const dataPlatilla: Plantilla = {
        data: JSON.stringify(this.partidos),
      };

      if (plantillas.length != 0) {
        this.PlantillasService.updatePlantilla(dataPlatilla, plantillas[0].$key).then((res) => {
          console.log("Se ha edito la plantilla.")
        });
      } else {
        this.PlantillasService.createPlantilla(dataPlatilla).then((res) => {
          console.log("Se ha guardado la nueva plantilla.")
        });
      }
    });
  }

}
